import BaseGrid from '@components/tables/BaseGrid';
import OrderLinkDetailsCellRenderer from '@components/tables/cells/OrderLinkDetailsCellRenderer';
import PaymentStatusCellRenderer from '@components/tables/cells/PaymentStatusCellRenderer';
import OrderStatusCellRenderer from '@components/tables/cells/OrderStatusCellRenderer';
import CopyToClipboardAndToggleCellRenderer from '@components/tables/cells/CopyToClipboardAndToggleCellRenderer';
import MultiLinesHeader from '@components/tables/headers/MultiLinesHeader';
import OrderStatusChipAgGrid from '@components/chips/OrderStatusChipAgGrid';
import OfferTokenStatusChip from '@components/chips/OfferTokenStatusChip';
import FilterFormRow from '@components/forms/FilterFormRow';
import FilterFormCell from '@components/forms/FilterFormCell';

import '@scss/main.scss';
import { appFactory } from '@/helpers';

const app = appFactory.create({});

app.component('BaseGrid', BaseGrid);
app.component('OrderLinkDetailsCellRenderer', OrderLinkDetailsCellRenderer);
app.component('PaymentStatusCellRenderer', PaymentStatusCellRenderer);
app.component('OrderStatusCellRenderer', OrderStatusCellRenderer);
app.component('CopyToClipboardAndToggleCellRenderer', CopyToClipboardAndToggleCellRenderer);
app.component('MultiLinesHeader', MultiLinesHeader);
app.component('OrderStatusChipAgGrid', OrderStatusChipAgGrid);
app.component('FilterFormRow', FilterFormRow);
app.component('FilterFormCell', FilterFormCell);
app.component('OfferTokenStatusChip', OfferTokenStatusChip);
